export const ROUTE_NAME = { directions: 'directions' };

export enum EDirectionRoutePointType {
  address = 'address',
  rawAddress = 'raw_address',
  territory = 'territory',
  radius = 'radius',
  code = 'code',
}
